import { render, staticRenderFns } from "./FormDetailUiModal.vue?vue&type=template&id=b0114ee2&scoped=true&"
import script from "./FormDetailUiModal.vue?vue&type=script&lang=js&"
export * from "./FormDetailUiModal.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailUiModal.vue?vue&type=style&index=0&id=b0114ee2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0114ee2",
  null
  
)

export default component.exports